const regexOutcode =
  /^([Gg][Ii][Rr])|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))))/

export const regexPostcode =
  /^(([Gg][Ii][Rr] ?0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) ?[0-9][A-Za-z]{2}))$/

export const regexPartPostcode = /^$|^[A-Za-z][A-Za-z0-9\s]*$/

export const getOutcode = (postcode) => {
  const match = postcode.match(regexOutcode)
  return match && match.filter((match) => match)[0]
}

export const formatPostcode = (postcode) => {
  if (isValidPostcode(postcode)) {
    const outcode = postcode.slice(0, -3).trim()
    const incode = postcode.slice(-3)
    return `${outcode} ${incode}`.toUpperCase()
  } else {
    return postcode
  }
}

export const isValidPostcode = (postcode) => regexPostcode.test(postcode)

export const isValidPartPostcode = (postcode) => regexPartPostcode.test(postcode)
